package ui.widget

import androidx.compose.foundation.layout.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.unit.*

@Composable
fun Space(width: Dp, height: Dp = width) {
    Spacer(Modifier.size(width, height))
}
